document.addEventListener('DOMContentLoaded', function () {
  // :not(:first-child) porque el CSS ya no oculta la primera seccion (es el
  // elemento LCP) -- no tiene sentido observarla tampoco.
  var sections = document.querySelectorAll('#MainContent > .shopify-section:not(:first-child)');

  if (!sections.length) return;

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (section) {
      section.classList.add('scroll-reveal-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px -60px 0px' }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
});
